/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { getApplicationLocalStorageItem } from "../../helpers"

export default {
  navigationString(state) {

    if (state.navigationHistory) {

      return state.navigationHistory.reduce((accumulator, currentValue) => {
        if (accumulator === '') {
          return `${currentValue.value}`
        } else {
          if (!accumulator.includes(currentValue.value)) {
            return `${accumulator} - ${currentValue.value}`
          } else {
            return `${accumulator}`
          }
        }
      }, '')
    } else {
      return ''
    }
  }
}
